import React, { createContext, useState, useContext, useEffect } from 'react';
import sanctumApi from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const checkAuth = async () => {
      const token = localStorage.getItem('sanctum_token');
      if (token) {
        try {
          const userData = await sanctumApi.getCurrentUser();
          setUser(userData);
        } catch (error) {
          console.error('Auth check failed:', error);
          sanctumApi.logout();
        }
      }
      setInitializing(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await sanctumApi.login(email, password);
      if (response.user) {
        setUser(response.user);
        return true;
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    sanctumApi.logout();
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    initializing,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {!initializing && children}
    </AuthContext.Provider>
  );
};